var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('h5', {
    staticClass: "d-flex align-center "
  }, [_vm._v(" " + _vm._s(_vm.title) + " "), _vm.value.ref && _vm.value.ref.refId ? _c('v-chip', {
    staticClass: "ml-1",
    attrs: {
      "x-small": ""
    },
    on: {
      "click": function click($event) {
        _vm.isSideCardActive = true;
      }
    }
  }, [_vm.value.ref.refType === _vm.ResourceEnum.COMPANY ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("BackendResourceEnum.".concat(_vm.ResourceEnum.COMPANY))) + " ")]) : _vm.value.ref.refType === _vm.ResourceEnum.PERSON ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("BackendResourceEnum.".concat(_vm.ResourceEnum.PERSON))) + " ")]) : _vm._e(), !_vm.readonly ? _c('v-btn', {
    attrs: {
      "icon": "",
      "x-small": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.removeRef.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v(" mdi-close ")])], 1) : _vm._e()], 1) : _vm._e()], 1)])], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pr-2",
    attrs: {
      "fr": "12",
      "md": "7"
    }
  }, [_c('span', {
    staticClass: "text-caption ",
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v(_vm._s(_vm.$t("objects.company.invoiceAddress")))]), _c('v-text-field', {
    staticClass: "mt-n2",
    attrs: {
      "placeholder": _vm.$t('objects.invoiceParty.name') + ' *',
      "dense": "",
      "hide-details": "",
      "persistent-hint": "",
      "readonly": _vm.readonly || _vm.isCompanySelect,
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.name,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "name", $$v);
      },
      expression: "value.name"
    }
  }), _c('v-text-field', {
    attrs: {
      "placeholder": _vm.$t('objects.invoiceParty.address.line1') + ' *',
      "dense": "",
      "hide-details": "",
      "readonly": _vm.readonly || _vm.isCompanySelect,
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.address.street,
      callback: function callback($$v) {
        _vm.$set(_vm.value.address, "street", $$v);
      },
      expression: "value.address.street"
    }
  }), _c('v-text-field', {
    attrs: {
      "placeholder": _vm.$t('objects.invoiceParty.address.line2'),
      "dense": "",
      "hide-details": "",
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.value.address.line2,
      callback: function callback($$v) {
        _vm.$set(_vm.value.address, "line2", $$v);
      },
      expression: "value.address.line2"
    }
  }), _c('v-text-field', {
    attrs: {
      "placeholder": _vm.$t('objects.invoiceParty.address.line3'),
      "dense": "",
      "hide-details": "",
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.value.address.line3,
      callback: function callback($$v) {
        _vm.$set(_vm.value.address, "line3", $$v);
      },
      expression: "value.address.line3"
    }
  }), _c('v-text-field', {
    attrs: {
      "placeholder": _vm.$t('objects.address.zip'),
      "dense": "",
      "hide-details": "",
      "readonly": _vm.readonly || _vm.isCompanySelect
    },
    model: {
      value: _vm.value.address.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.value.address, "zip", $$v);
      },
      expression: "value.address.zip"
    }
  }), _c('v-text-field', {
    attrs: {
      "placeholder": _vm.$t('objects.address.city'),
      "dense": "",
      "hide-details": "",
      "readonly": _vm.readonly || _vm.isCompanySelect
    },
    model: {
      value: _vm.value.address.city,
      callback: function callback($$v) {
        _vm.$set(_vm.value.address, "city", $$v);
      },
      expression: "value.address.city"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_vm.isCompany ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.invoiceParty.taxnumber'),
      "hide-details": "",
      "persistent-hint": "",
      "readonly": _vm.readonly || _vm.isCompanySelect
    },
    model: {
      value: _vm.value.taxnumber,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "taxnumber", $$v);
      },
      expression: "value.taxnumber"
    }
  }) : _vm._e(), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.invoiceParty.email'),
      "hide-details": "",
      "persistent-hint": "",
      "readonly": _vm.readonly || _vm.isCompanySelect
    },
    model: {
      value: _vm.value.email,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "email", $$v);
      },
      expression: "value.email"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.invoiceParty.phone'),
      "hide-details": "",
      "persistent-hint": "",
      "readonly": _vm.readonly || _vm.isCompanySelect
    },
    model: {
      value: _vm.value.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "phone", $$v);
      },
      expression: "value.phone"
    }
  })], 1)], 1), _vm.person && _vm.isSideCardActive ? _c('person-side-card', {
    attrs: {
      "value": _vm.person
    },
    on: {
      "close": function close($event) {
        _vm.isSideCardActive = false;
      }
    }
  }) : _vm._e(), _vm.company && _vm.isSideCardActive ? _c('company-side-card', {
    attrs: {
      "value": _vm.company
    },
    on: {
      "close": function close($event) {
        _vm.isSideCardActive = false;
      }
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }